module.exports = __webpack_public_path__ + "img/ic_manager_reply_rate.2f7b4a84.png";